import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=203606a2&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203606a2')) {
      api.createRecord('203606a2', component.options)
    } else {
      api.reload('203606a2', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=203606a2&", function () {
      api.rerender('203606a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/menu.vue"
export default component.exports